/**
 * Claude's "add custom connector" deep link. URLSearchParams already percent-encodes the values -
 * an extra encodeURIComponent would double-encode the MCP URL (`%253A`). It also turns spaces into
 * `+`, so the connector name must stay space-free.
 */
export function buildClaudeConnectorUrl(mcpServerUrl: string): string {
  const url = new URL('https://claude.ai/customize/connectors');

  url.searchParams.set('modal', 'add-custom-connector');
  url.searchParams.set('connectorName', 'ShikensoCampaign');
  url.searchParams.set('connectorUrl', mcpServerUrl);

  return url.toString();
}

// The storage is looked up inside the try as well: merely accessing it throws when site data is blocked.
export function readAiConnectorStorage(
  key: string,
  storage: 'localStorage' | 'sessionStorage' = 'localStorage',
): string | null {
  try {
    return window[storage].getItem(key);
  } catch {
    return null;
  }
}

export function writeAiConnectorStorage(
  key: string,
  value: string,
  storage: 'localStorage' | 'sessionStorage' = 'localStorage',
): void {
  try {
    window[storage].setItem(key, value);
  } catch {
    // Ignore storage errors
  }
}
